var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "invoiceWrite"
  }, [_c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_vm.$route.params.num > 1 ? [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("开具发票方式")))])]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("开具发票方式"),
      prop: "type"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("开具发票方式")
    },
    on: {
      change: _vm.invoiceTypeChange
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, _vm._l(_vm.invoiceTypeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1)] : _vm._e(), _vm.form.type ? [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("发票信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("抬头类型"),
      prop: "taxpayerType"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("抬头类型")
    },
    on: {
      change: _vm.taxpayerTypeChange
    },
    model: {
      value: _vm.form.taxpayerType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "taxpayerType", $$v);
      },
      expression: "form.taxpayerType"
    }
  }, _vm._l(_vm.invoiceHeadTypeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _vm.form.taxpayerType === "C" ? [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("发票抬头"),
      prop: "invoiceHead"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("发票抬头"),
      maxLength: 40
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("invoiceHead");
      }
    },
    model: {
      value: _vm.form.invoiceHead,
      callback: function ($$v) {
        _vm.$set(_vm.form, "invoiceHead", $$v);
      },
      expression: "form.invoiceHead"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("纳税人识别号"),
      prop: "taxpayerNo"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("纳税人识别号"),
      maxLength: 20
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("taxpayerNo");
      }
    },
    model: {
      value: _vm.form.taxpayerNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "taxpayerNo", $$v);
      },
      expression: "form.taxpayerNo"
    }
  })], 1)] : [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("开票姓名"),
      prop: "invoiceHead"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("开票姓名"),
      maxLength: 25
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("invoiceHead");
      }
    },
    model: {
      value: _vm.form.invoiceHead,
      callback: function ($$v) {
        _vm.$set(_vm.form, "invoiceHead", $$v);
      },
      expression: "form.invoiceHead"
    }
  })], 1)], _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("发票内容")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.$t("保险费"),
      disabled: true
    }
  })], 1), _vm.form.type === "SINGLE" || _vm.form.type === "MULTIPLE" ? _vm._l(_vm.invoiceList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "moneyBox"
    }, [_c("a-form-model-item", {
      attrs: {
        label: _vm.$t("序号")
      }
    }, [_c("a-input", {
      attrs: {
        value: index + 1,
        disabled: true
      }
    })], 1), _c("a-form-model-item", {
      attrs: {
        label: _vm.$t("金额")
      }
    }, [_c("a-input", {
      attrs: {
        value: item.premium,
        disabled: true
      }
    })], 1)], 1);
  }) : _vm._e(), _vm.form.type === "MERGE" ? [_c("div", {
    staticClass: "moneyBox"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("序号")
    }
  }, [_c("a-input", {
    attrs: {
      value: "1",
      disabled: true
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("金额")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.invoicePrice,
      disabled: true
    }
  })], 1)], 1)] : _vm._e(), _vm.form.taxpayerType === "C" ? [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("开户行名称"),
      prop: "companyBank"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("开户行名称"),
      maxLength: 40
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("companyBank");
      }
    },
    model: {
      value: _vm.form.companyBank,
      callback: function ($$v) {
        _vm.$set(_vm.form, "companyBank", $$v);
      },
      expression: "form.companyBank"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("开户行账号"),
      prop: "companyAccount"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("开户行账号"),
      maxLength: 20
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("companyAccount");
      }
    },
    model: {
      value: _vm.form.companyAccount,
      callback: function ($$v) {
        _vm.$set(_vm.form, "companyAccount", $$v);
      },
      expression: "form.companyAccount"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("公司联系电话"),
      prop: "companyTel"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("公司联系电话"),
      maxLength: 13
    },
    on: {
      input: _vm.mobileInput,
      blur: function ($event) {
        return _vm.handleBlurTrim("companyTel");
      }
    },
    model: {
      value: _vm.form.companyTel,
      callback: function ($$v) {
        _vm.$set(_vm.form, "companyTel", $$v);
      },
      expression: "form.companyTel"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("公司地址"),
      prop: "companyAddress"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("公司地址"),
      maxLength: 60
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("companyAddress");
      }
    },
    model: {
      value: _vm.form.companyAddress,
      callback: function ($$v) {
        _vm.$set(_vm.form, "companyAddress", $$v);
      },
      expression: "form.companyAddress"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注信息"),
      prop: "remark"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("备注信息"),
      maxLength: 100
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("remark");
      }
    },
    model: {
      value: _vm.form.remark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  })], 1)] : _vm._e()], 2), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("接收方式")))])]), _c("div", {
    staticClass: "infoBox"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("手机号"),
      prop: "mobile"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("手机号")
    },
    on: {
      input: function ($event) {
        _vm.form.mobile = _vm.form.mobile.replace(/[^\d]/g, "");
      },
      blur: function ($event) {
        return _vm.handleBlurTrim("mobile");
      }
    },
    model: {
      value: _vm.form.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mobile", $$v);
      },
      expression: "form.mobile"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("电子邮箱"),
      prop: "email"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("电子邮箱")
    },
    on: {
      blue: function ($event) {
        return _vm.handleBlurTrim("email");
      }
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1)], 1), _c("a-form-model-item", {
    staticStyle: {
      width: "100%",
      "margin-top": "24px"
    },
    attrs: {
      "wrapper-col": {
        span: 24,
        offset: 12
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("提交")) + " ")])], 1)] : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };